import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4100fee5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "station-selector-wrapper" }
const _hoisted_3 = { class: "row flex flex-center" }

import { watch, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import CurrentDataPanel from '@/components/rain_detail/CurrentDataPanel.vue'
import GraphPanel from '@/components/rain_detail/GraphPanel.vue'
import SimpleHistoriesPanel from '@/components/rain_detail/SimpleHistoriesPanel.vue'
import StationSelector from '@/components/common/StationSelector.vue'
import { useGlobalStore } from '@/stores/globalStore'
import { useInitDataStore } from '@/stores/initDataStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const route = useRoute()
const router = useRouter()
const stationId = computed(() => {
  return globalStore.currentStation?.stationId
})

const attachCurrentStation = () => {
  const station = initDataStore.initData.stationList.find(station => station.stationId === route.params.stationId)
  const areaCode = station?.areaCode[0]

  if (!areaCode) {
    return
  }

  const area = initDataStore.areaList.find(area => area.id === areaCode)

  globalStore.currentArea = area
  globalStore.currentStation = station
}

onMounted(() => {
  attachCurrentStation()
})

watch(initDataStore, attachCurrentStation)

watch(stationId, () => {
  const path = `/rain_detail/${stationId.value}`

  router.replace(path)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(StationSelector, { "station-type": "rain" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CurrentDataPanel),
      _createVNode(GraphPanel, { class: "hide-sp" })
    ]),
    _createVNode(SimpleHistoriesPanel, { class: "hide-sp" })
  ]))
}
}

})